import {Store} from '@/stores/Store';

type UserEnergyState = {
  value: number;
  nextIn: number | null;
  maxValue: number;
};
type UpdateUserEnergyInput = {
  value: number;
  nextIn: number;
};

const initialState: UserEnergyState = {
  value: 0,
  maxValue: 0,
  nextIn: null,
};

// Выносим доступные возможности для открытия items в отдельный стор,
// т.к. при обновлении UserStore таймер сбрасывается
export class UserEnergyStore extends Store<UserEnergyState> {
  constructor() {
    super(initialState);
  }

  public setUserEnergy(userEnergy: UserEnergyState): void {
    const {value, nextIn} = this.calculateUserEnergyState(userEnergy);

    this.setState({
      value,
      maxValue: userEnergy.maxValue,
      nextIn,
    });
  }

  public getUserEnergy(): UserEnergyState {
    return this.getState();
  }

  public getUserNextEnergyInSec(): number {
    return Math.round((this.getUserEnergy().nextIn || 0) / 1000);
  }

  public updateUserEnergyValue = ({value, nextIn}: UpdateUserEnergyInput): void => {
    const currentUserEnergy = this.getUserEnergy();

    this.setState({
      ...currentUserEnergy,
      value,
      nextIn,
    });
  };

  private calculateUserEnergyState = ({
    value,
    maxValue,
    nextIn,
  }: UserEnergyState): {
    value: number;
    nextIn: number | null;
  } => {
    const userEnergyValue = Math.min(value, maxValue);
    const userEnergyNextIn = value >= maxValue ? null : nextIn;

    return {
      value: userEnergyValue,
      nextIn: userEnergyNextIn,
    };
  };
}
